import { css } from "@linaria/core";
import cx from "classnames";
import React from "react";
import type { BlockTextModelT } from "../../../../../schema/block/text";

import { Markdown } from "@ui/Markdown";
import { DEFAULT_CONFIG_TABLE } from "@ui/Markdown/plugins/Table/utils/config";
import { DEFAULT_CLASSNAME_THEME_TABLE } from "@ui/Markdown/plugins/Table/utils/style";
import { convertFromMarkdown } from "@ui/Markdown/plugins/common/MarkdownConverterPlugin";
import { EquationNode } from "@ui/Markdown/plugins/Equation/nodes/EquationNode";

const Content = css`
  font: inherit;
  max-width: 100%;
  line-break: strict;
  white-space: pre-wrap;
`;

export const BlockRichText = React.memo(
  ({ block, className }: { block: BlockTextModelT; className?: string }) => (
    <div className={cx(Content, className)}>
      <Markdown
        config={{
          nodes: [EquationNode, ...DEFAULT_CONFIG_TABLE.nodes],
          theme: DEFAULT_CONFIG_TABLE.theme,
          editorState: () => convertFromMarkdown(block.data),
        }}
        theme={DEFAULT_CLASSNAME_THEME_TABLE}
      />
    </div>
  ),
);
